import styled from 'styled-components'
import { RotaPatternEditForm } from '../RotaPattern'
import useHomeType from 'hooks/useHomeType'

export const RotaEditShiftsScreen = () => {
  const { hasRota } = useHomeType()

  if (!hasRota) {
    return null
  }

  return (
    <PageContainer>
      <RotaPatternEditForm type="shift" />
    </PageContainer>
  )
}

const PageContainer = styled.div`
  padding: 24px 48px;
  display: flex;
  flex-direction: column;
  gap: 24px;
  max-width: 1080px;
  margin-left: auto;
  margin-right: auto;
`
